"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElLogName = (el) => {
    return ('<' +
        (typeof Document !== 'undefined' && el instanceof Document
            ? 'Document'
            : el.nodeType === el.DOCUMENT_FRAGMENT_NODE
                ? 'DocumentFragment'
                : el.tagName) +
        '>');
};
//# sourceMappingURL=getElLogName.js.map